import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DISTRIBUTION_REPORT_API } from "./apiRoutes";
interface UseGetTraceabilityReportByGLProps {
  communityId: string;
  year: string;
  glMasterId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getTraceabilityReportByGL = async (communityId: string, year: string, glMasterId: string) =>
  await axiosAuth.get(`${DISTRIBUTION_REPORT_API}/${communityId}/year/${year}/reports/traceability/${glMasterId}`);

const useGetTraceabilityReportByGL = ({
  queryParams,
  communityId,
  year,
  glMasterId
}: UseGetTraceabilityReportByGLProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["traceability-report-by-id", communityId, year, glMasterId],
    queryFn: () => getTraceabilityReportByGL(communityId, year, glMasterId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetTraceabilityReportByGL;
